/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class LoadDigitizeConfig {
    static readonly type = '[Digitize] Load Digitize Point config';

    constructor(public mapName: string) {}
}
